import { axios, BaseApiUrl, BaseUrl } from "../axios_config";

// 第三方质检服务列表
export const GetQCCheckInfoTaskListAsync = (params) => {
	return axios
		.post(`${BaseApiUrl}/QCCheckInfo/GetQCCheckInfoTaskListAsync`, {
			...params,
		})
		.then((res) => res.data);
};

export function GetQCCheckInfoBasis(params) {
	return axios.get(`${BaseApiUrl}/QCCheckInfo/GetQCCheckInfoBasis`, {
		params: params,
	});
}

// 修改质检状态
export const EditQCCheckInfoStatus = (params) => {
	return axios.post(`${BaseApiUrl}/QCCheckInfo/EditQCCheckInfoStatus`, {
		...params,
	});
};

// 检测完成
export const CompleteQCCheckInfo = (params) => {
	return axios.post(`${BaseApiUrl}/QCCheckInfo/CompleteQCCheckInfo`, {
		...params,
	});
};

// 创建质检单
export const InsertQCCheckInfo = (params) => {
	return axios.post(`${BaseApiUrl}/QCCheckInfo/InsertQCCheckInfo`, {
		...params,
	});
};

// 导出
export const QCCheckInfoAsyncOut = `${BaseApiUrl}/QCCheckInfo/QCCheckInfoAsyncOut`;
